import * as types from '../../index.types';

// ============ TASKS ============
export const getTasksList = (data) => ({ type: types.SOCIETY_GET_TASKS_LIST, data });
export const createTask = (data) => ({ type: types.SOCIETY_CREATE_TASK, data });
export const getTaskDetails = (data) => ({ type: types.SOCIETY_GET_TASK_DETAILS, data });
export const updateTask = (data) => ({ type: types.SOCIETY_UPDATE_TASK, data });
export const deleteTask = (data) => ({ type: types.SOCIETY_DELETE_TASK, data });
export const cloneTask = (data) => ({ type: types.SOCIETY_CLONE_TASK, data });
export const getTaskHistory = (data) => ({ type: types.SOCIETY_GET_TASK_HISTORY, data });

// ============ WORKFLOW ============
export const transitionTask = (data) => ({ type: types.SOCIETY_TRANSITION_TASK, data });
export const changeTaskPriority = (data) => ({ type: types.SOCIETY_CHANGE_TASK_PRIORITY, data });
export const changeTaskTitle = (data) => ({ type: types.SOCIETY_CHANGE_TASK_TITLE, data });

// ============ ASSIGNMENT ============
export const assignTask = (data) => ({ type: types.SOCIETY_ASSIGN_TASK, data });
export const selfAssignTask = (data) => ({ type: types.SOCIETY_SELF_ASSIGN_TASK, data });
export const reassignTask = (data) => ({ type: types.SOCIETY_REASSIGN_TASK, data });
export const delegateTask = (data) => ({ type: types.SOCIETY_DELEGATE_TASK, data });
export const removeAssignee = (data) => ({ type: types.SOCIETY_REMOVE_TASK_ASSIGNEE, data });

// ============ WATCHERS ============
export const addWatcher = (data) => ({ type: types.SOCIETY_ADD_TASK_WATCHER, data });
export const removeWatcher = (data) => ({ type: types.SOCIETY_REMOVE_TASK_WATCHER, data });

// ============ COMMENTS ============
export const getComments = (data) => ({ type: types.SOCIETY_GET_TASK_COMMENTS, data });
export const addComment = (data) => ({ type: types.SOCIETY_ADD_TASK_COMMENT, data });
export const uploadCommentAttachments = (data) => ({ type: types.SOCIETY_UPLOAD_TASK_COMMENT_ATTACHMENTS, data });

// ============ CHECKLIST ============
export const addChecklistItem = (data) => ({ type: types.SOCIETY_ADD_TASK_CHECKLIST, data });
export const toggleChecklistItem = (data) => ({ type: types.SOCIETY_TOGGLE_TASK_CHECKLIST, data });
export const deleteChecklistItem = (data) => ({ type: types.SOCIETY_DELETE_TASK_CHECKLIST, data });

// ============ DEPENDENCIES ============
export const addDependency = (data) => ({ type: types.SOCIETY_ADD_TASK_DEPENDENCY, data });
export const removeDependency = (data) => ({ type: types.SOCIETY_REMOVE_TASK_DEPENDENCY, data });

// ============ ATTACHMENTS ============
export const uploadAttachment = (data) => ({ type: types.SOCIETY_UPLOAD_TASK_ATTACHMENT, data });
export const deleteAttachment = (data) => ({ type: types.SOCIETY_DELETE_TASK_ATTACHMENT, data });

// ============ PROJECTS ============
export const getProjectsList = (data) => ({ type: types.SOCIETY_GET_TASK_PROJECTS, data });
export const createProject = (data) => ({ type: types.SOCIETY_CREATE_TASK_PROJECT, data });
export const getProjectDetails = (data) => ({ type: types.SOCIETY_GET_TASK_PROJECT_DETAILS, data });
export const updateProject = (data) => ({ type: types.SOCIETY_UPDATE_TASK_PROJECT, data });
export const deleteProject = (data) => ({ type: types.SOCIETY_DELETE_TASK_PROJECT, data });

// ============ COLLECTION ============
export const bulkCreateTasks = (data) => ({ type: types.SOCIETY_BULK_CREATE_TASKS, data });
export const getTaskDashboard = (data) => ({ type: types.SOCIETY_GET_TASK_DASHBOARD, data });
